import { MojoContextCoreType } from '../types';
import { getPartnerMeta } from './getPartnerMeta';
import { getVendorIdByUrl } from './getVendorIdByUrl';
import { DEFAULT_CARVANA_URL, DEFAULT_ORIGIN_VENDOR } from './urlMappings/constants';

export const getOriginContext = (): MojoContextCoreType => {
  const url = window.location.href;
  const vendorId = getVendorIdByUrl(url) || DEFAULT_ORIGIN_VENDOR;
  const meta = getPartnerMeta();
  return {
    origin: {
      meta,
      url,
      name: DEFAULT_CARVANA_URL,
      vendor_id: vendorId,
    },
  };
};
